export const CRUD_CONSTS = {
  moduleName: 'epb-crud',

  getters: {
    state: 'state'
  },
  actions: {
    list: 'list',
    create: 'create',
    read: 'read',
    update: 'update',
    delete: 'delete',
    setEnabled: 'setEnabled',

    fetchData: 'fetchData'
  },
  mutations: {
    setState: 'setState'
  }

};
